import StudentBehaviourAlternatives from '@/utils/constants/pei/inappropiateConductAlternatives.js';

export const StudentInappropiateBehaviourOptions = [
  { id: StudentBehaviourAlternatives.Destructive, name: 'Destructivas' },
  { id: StudentBehaviourAlternatives.Inappropiate, name: 'Inapropiadas' },
];